import React from "react";
import { useTranslation } from "react-i18next";
import PromptDialog from "./PromptDialog";
import type { Class } from "types/Class";

interface DeleteConfirmationDialogProps {
  classItem: Class;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  classItem,
  onCancel,
  onConfirm,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  const className = `${classItem.year}-${classItem.name}`;

  return (
    <PromptDialog
      title={t("_class.confirm_deletion", {
        defaultValue: "本当に削除しますか？",
      })}
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmText={t("_generic.delete", { defaultValue: "削除する" })}
      cancelText={t("_generic.cancel", { defaultValue: "キャンセル" })}
      isLoading={isLoading}
      message={
        <div className="space-y-3 text-center">
          <p className="text-lg">
            {t("_class.confirm_delete_class", {
              name: className,
              defaultValue: "{{name}} クラスを削除しますか？",
            })}
          </p>
          <p className="text-sm text-red-500">
            {t("_class.deleted_data_unrecoverable", {
              defaultValue: "削除した園児のデータは復元することができません。",
            })}
          </p>
        </div>
      }
    />
  );
};

export default DeleteConfirmationDialog;
